import { ref } from 'vue'
import type { Ref } from 'vue'
import { api } from '@/api'
import { useToastStore } from '@/stores'
import { useElementClick } from '@/composables/tracks/useElementClick'
import { t } from '@/i18n/utils'

export function useBookshelf(book: Ref<{ id: string } | undefined>) {
  const { $toast } = useToastStore()
  const { elementClick } = useElementClick()
  const isInShelf = ref(false)
  const shelfLoading = ref(false)

  async function toggle() {
    if (!book.value || shelfLoading.value)
      return

    const next = !isInShelf.value
    shelfLoading.value = true
    try {
      if (next) {
        await api.post<any, PostBookshelfAddResponse>('/bookshelf/add', { contentId: book.value.id })
        elementClick('add_shelf')
        $toast(t('BookshelfAddSuccess'))
      }
      else {
        await api.post<any, PostBookshelfDelResponse>('/bookshelf/del', { contentIds: [book.value.id] })
        elementClick('remove_shelf')
      }
      isInShelf.value = next
    }
    finally {
      shelfLoading.value = false
    }
  }

  return { isInShelf, shelfLoading, toggle }
}
